export default __webpack_public_path__ + "static/media/qx.a77c1c08.png";